import http from "@/utils/http";

export default {
    /*
    *
      分页查询组织员工
    * */
    findEmployeePageList(query) {
        return http.get("/system/user/page", query);
    },
    /*
     *
     *rqmei 20230818 bug:16201 分页查询组织员工
     * */
    findUserPageList(query) {
        return http.get("/system/user/little/page", query);
    },
    /*
     * 单条查询组织员工
     * */
    getOne(params) {
        return http.get("/system/orgUser/one", params);
    },
    /*
     * 新增组织员工
     * */
    add(params) {
        return http.post("/system/user/add", params);
    },
    /*
     *逻辑删除组织员工
     * */
    del(parmams) {
        return http.delete("/system/user/del", parmams);
    },
    /*
    *
      修改组织员工
    * */
    update(params) {
        return http.put("/system/user/mod", params);
    },

    /*
     * 重置密码
     * */
    resetPass(params) {
        return http.put("/system/user/password/mod", params);
    },
    /*
     *  修改状态
     * */
    modifyState(params) {
        return http.put("/system/user/state", params);
    },
    /*
       *
         修改组织员工状态
       * */
    modifyOrgUserState(params) {
        return http.put("/system/orguser/state", params);
    },
    /**
     *  查询系统默认密码
     */
    findDefaultPassword(params) {
        return http.get("/common/user/defaultpassword", params);
    },

    /**
     * 查询组织员工列表
     */
    findOrgUserEmployeeList(params) {
        return http.get("/system/user/list", params);
    },
    /**
     * 验证用户是否为部门负责人(员工修改所属部门)
     */
    checkEmployeeDeparatmentRequest(params) {
        return http.get("/system/orguser/department/manage", params);
    },

    /**
     * 审核列表
     * @param params
     */
    getExaminePage(params) {
        return http.get("", params);
    },
    /**
     * 通过证件号，手机，邮件查询基本信息 1.0.9
     * @param params
     */
    getUserBaseInfo(params) {
        return http.get("/system/user/info/card/mobile/email", params);
    },
    /**
     *  通过证件号，手机，邮件校验基本信息--1.0.9
     * @param params
     */
    checkSingleInfo(params) {
        return http.post("/api/system/user/valid/card/mobile/email", params);
    },
    /**
     * 发送验证码
     * @param params
     */
    sendCode(params) {
        return http.get("/api/system/user/send/code", params);
    },
    /**
     * @description: 转让管理员 20221201 lzb
     * @param {*} param 参数
     * @return {*}
     */
    transferAdmin(param) {
        return http.post("/org/user/transfer/transfer", param);
    },
    /**
     * @description: 转让管理员list 20221201 lzb
     * @param {*} param 参数
     * @return {*}
     */
    getTransferList(param) {
        return http.get("/org/user/transfer/list", param);
    },
    /**
     * @description: 转让管理员page 20221201 lzb
     * @param {*} param 参数
     * @return {*}
     */
    getTransferPage(param) {
        return http.get("/org/user/transfer/page", param);
    },

    /**
     * 检查用户必填字符是否全部填写P1.0.36 lzb
     */
    checkUserRequireIsFill(param) {
        return http.get("/user/required/isFill", param);
    },
    /**
     * 获取学员必填字段 P1.0.36 lzb
     */
    fetchUserRequiredParam(param) {
        return http.get("/user/required/param", param);
    },
    /**
     * 获取组织用户扩展信息（如行业列表）
     */
    findOrgUserExtJson(params) {
        return http.get("/system/orguser/extjson", params);
    },
};

/**
 * 批量修改员工状态 2024-12-27 lzb 1.0.42
 */
export const putModOrgUserState = (param) => {
    return http.put("/system/orguser/batch/state", param);
};

/**
 * 所在企业是否开通了台账 - 20250427 yxl
 */
export const getOrgLedgerBusiness = (param) => {
    return http.get("/org/ledger/open/info", param);
};

/**
 * 所在企业是否有从业资格证相关展示 - 20250609 yxl
 */
export const postCertValid = (param) => {
    return http.post("/user/cert/form/valid", param);
};

/**
 * 获取后台的配置信息
 */
export const getCommonZKConfig = (param) => {
    return http.get("/common/config", param);
};

/**
 *
 * 获取员工可选角色 1.0.5 lzb 20251106
 */
export const getEmployeeOptionRoles = (param) => {
    return http.get("/system/role/user/list", param);
};
